import axios from "axios";

const API_BASE_URL = "http://localhost:5000";

// SIGNUP
export const register = (data) =>
  axios.post(`${API_BASE_URL}/api/auth/signup`, data);

export const adminLogin = (data) =>
  axios.post(`${API_BASE_URL}/api/auth/admin-login`, data);

export const userLogin = (data) =>
  axios.post(`${API_BASE_URL}/api/auth/login`, data);

export const getAllUsers = () =>
  axios.get(`${API_BASE_URL}/api/auth/users`);
export const getUsers = () =>
  axios.get(`${API_BASE_URL}/api/auth/users`);
// REMAINING APIs
export const createBooking = (data, token) =>
  axios.post(`${API_BASE_URL}/api/bookings`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });

export const getMyBookings = (token) =>
  axios.get(`${API_BASE_URL}/api/bookings/my-bookings`, {
    headers: { Authorization: `Bearer ${token}` },
  });
